var _circle, _path, _path2, _g, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExistinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#E4E9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 34c0 18.778-15.222 34-34 34S0 52.778 0 34 15.222 0 34 0s34 15.222 34 34z",
    fill: "#E4E9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.468 9.459C16.577 3.6 24.868 0 34 0c18.778 0 34 15.222 34 34 0 9.01-3.504 17.2-9.224 23.284L10.468 9.459z",
    fill: "#798FD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#existing_inline_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.133,
    y: 18.133,
    width: 31.733,
    height: 31.733,
    rx: 4,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.806 32.163l-3.651-3.651a9.595 9.595 0 000 10.976l3.65-3.65a4.602 4.602 0 010-3.675zM38.194 35.837l3.651 3.651a9.595 9.595 0 000-10.976l-3.65 3.65a4.602 4.602 0 010 3.675zM35.837 29.806l3.651-3.651a9.595 9.595 0 00-10.976 0l3.65 3.65a4.601 4.601 0 013.675 0zM32.163 38.194l-3.651 3.651a9.595 9.595 0 0010.976 0l-3.65-3.65a4.602 4.602 0 01-3.675 0z",
    fill: "#6B7696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.241 30.76c.416.415.731.893.953 1.403l3.651-3.651a9.571 9.571 0 00-1.069-1.288 9.571 9.571 0 00-1.288-1.07l-3.65 3.652c.509.222.987.537 1.403.953zM41.845 39.488l-3.65-3.65c-.223.509-.538.987-.954 1.403a4.551 4.551 0 01-1.404.953l3.651 3.651a9.57 9.57 0 001.288-1.069 9.563 9.563 0 001.07-1.288zM30.76 37.24a4.55 4.55 0 01-.954-1.403l-3.651 3.651c.316.452.666.886 1.069 1.288.402.403.837.754 1.288 1.07l3.65-3.652a4.55 4.55 0 01-1.403-.953zM30.76 30.76a4.551 4.551 0 011.403-.954l-3.651-3.651a9.57 9.57 0 00-1.288 1.069 9.563 9.563 0 00-1.07 1.288l3.652 3.65c.222-.509.537-.987.953-1.403z",
    fill: "#363C4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "existing_inline_svg__filter0_d",
    x: 10.133,
    y: 18.133,
    width: 47.733,
    height: 47.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.172965 0 0 0 0 0.162254 0 0 0 0 0.366665 0 0 0 0.49867 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default SvgExistinginline;